import { render, staticRenderFns } from "./Wp_order_count_self_detail_page.vue?vue&type=template&id=800c7940&scoped=true&"
import script from "./Wp_order_count_self_detail_page.vue?vue&type=script&lang=js&"
export * from "./Wp_order_count_self_detail_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800c7940",
  null
  
)

export default component.exports